<jni-loader [showLoader]="showLoader"></jni-loader>
<router-outlet></router-outlet>
